<template>
  <el-row class="users-managment">
    <el-row
      v-loading="loading"
      v-if="isLocationAvailable"
      class="user-access-container"
    >
      <el-row>
        <el-col :span="10" class="sub-header-left">
          <el-col :span="4">
            <er-list-filter
              :data="userTypes"
              value-key="key"
              search-on-key="label"
              :defaultCheckedKeys="getUAMListArrayIds"
              @check-change="handleChangeSelectedUsers"
            >
              <template v-slot:label="{ item }">{{ item.label }}</template>
            </er-list-filter>
          </el-col>
          <el-col :span="12">
            <er-input
              inputType="search"
              v-model="userSearch"
              size="mini"
              class="input-search-pond"
              suffix-icon="el-icon-search"
              :placeholder="$t('Comn_search')"
            ></er-input>
          </el-col>
          <el-col :span="8" class="add-user-btn">
            <er-button
              btnType="circle_add"
              :showLabel="true"
              :showIcon="true"
              size="mini"
              @click="handleClick('', 'userAccessMgmtCreate')"
            >
              <slot>
                <p>
                  {{ `${$t("Comn_add")} ${$t("Comn_users")}` }}
                </p>
              </slot>
            </er-button>
          </el-col>
        </el-col>
        <el-col :span="14" class="sub-header-right">
          <el-row v-if="rightPanelViewType === 'details'" style="width: 100%;">
            <el-col :span="12" class="name-container">
              <img class="img-icon" src="@/assets/settings/user.svg" />
              <p class="captalize">
                {{ getUserData ? getUserData.name : "" }}
              </p>
              <el-tag>{{
                getUserData ? $t(USER_TYPE[getUserData.user_type]) : ""
              }}</el-tag>
            </el-col>
            <el-col :span="12" class="outline-btns-container">
              <er-button
                btnType="outlinePassword"
                :showLabel="true"
                :showIcon="true"
                size="mini"
                @click="handleClick('', 'userAccessMgmtUpdatePassword')"
              >
                <slot>
                  <p>
                    {{ $t("Comn_chng_pwd") }}
                  </p>
                </slot>
              </er-button>
              <er-button
                btnType="outlineEdit"
                :showLabel="true"
                :showIcon="true"
                size="mini"
                @click="handleClick('', 'userAccessMgmtEdit')"
              >
                <slot>
                  <p>
                    {{ `${$t("Comn_edit")} info` }}
                  </p>
                </slot>
              </er-button>
            </el-col>
          </el-row>
          <el-row
            v-else-if="rightPanelViewType === 'userAccessMgmtCreate'"
            style="width: 100%;"
          >
            <el-col :span="12" class="add-container">
              <img class="img-icon" src="@/assets/settings/add-user.svg" />
              <p>
                {{ `${$t("Comn_add")} ${$t("Comn_users")}` }}
              </p>
            </el-col>
          </el-row>
          <el-row
            v-else-if="rightPanelViewType === 'userAccessMgmtEdit'"
            style="width: 100%;"
          >
            <el-col :span="12" class="add-container">
              <img class="img-icon" src="@/assets/settings/add-user.svg" />
              <p>{{ `${$t("Comn_edit")} ${$t("Comn_users")}` }}</p>
            </el-col>
          </el-row>
          <el-row v-else style="width: 100%;">
            <el-col :span="12" class="add-container">
              <img class="img-icon" src="@/assets/settings/add-user.svg" />
              <p>{{ $t("Comn_chng_pwd") }}</p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-scrollbar
            class="user-table-scroll"
            viewClass="user-table-scroll-view"
            wrapClass="user-table-scroll-wrap"
          >
            <er-data-tables
              :tableData="getUAMListArray"
              :columns="tableColumns"
              :el-table-props="tableProps"
              :action-column="false"
              :sortMethodForColumns="sortMethodForColumns"
              :key="$i18n.locale"
              type="white-header-table"
              layout="table"
              unique-id="user-access-managment__table"
              @row-click="handleRowClick"
            >
              <template v-slot:first_name="{ row }">
                <div>
                  <p class="table-header-text captalize">
                    {{ `${row.data.first_name} ${row.data.last_name}` }}
                  </p>
                  <p class="table-main-text">{{ row.data.email }}</p>
                </div>
              </template>
              <template v-slot:status="{ row }">
                <div
                  :class="
                    getStatus(row.data.user_type) === 'Active'
                      ? 'active-user-tag'
                      : 'inactive-user-tag'
                  "
                >
                  <span class="circle" />
                  <p>{{ getStatus(row.data.user_type) }}</p>
                </div>
              </template>
              <template v-slot:user_type="{ row }">
                <p class="table-main-text">
                  {{ $t(USER_TYPE[row.data.user_type]) }}
                </p>
              </template>
            </er-data-tables>
          </el-scrollbar>
        </el-col>
        <el-col :span="14" class="left-container">
          <user-details
            :type="rightPanelViewType"
            :data="getUserData"
            :key="this.selectedUser"
            @reload="reload"
            :loading="loading"
          />
        </el-col>
      </el-row>
    </el-row>
    <er-no-ponds :tabData="tabData" :disabled="isReadOnly" v-else />
  </el-row>
</template>

<script>
import erButton from "@/components/base/erButton";
import userDetails from "./userDetails";
import User from "@/model/user";
import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";
import { mapGetters } from "vuex";

export default {
  mixins: [errorHandlerMixin],
  props: {
    tabData: {
      default: {}
    }
  },
  components: {
    erButton,
    userDetails
  },
  data: function() {
    return {
      dialogVisible: false,
      actionComponentTitles: {},
      actionsComponent: "userAccessMgmtCreate",
      user_type: "pond_owner",
      UAMList: [],
      UAMNoAccessList: [],
      user_details: new User(),
      loading: false,
      disabled: true,
      selectedUser: "",
      rightPanelViewType: "details",
      userSearch: "",
      selectedUserIds: [],
      USER_TYPE: {
        ADMIN: "Admin",
        POND_OWNER: "Usrs_name_owner",
        POND_MANAGER: "Comn_managers",
        POND_WORKER: "Usrs_pond_name_worker",
        POND_TECHNICIAN: "Usrs_pond_techno",
        NO_ACCESS: "Comn_no_access"
      }
    };
  },
  computed: {
    ...mapGetters("user", {
      isReadOnly: "isReadOnly"
    }),
    userTypes() {
      return [
        { key: "ADMIN", label: "Admin" },
        { key: "POND_OWNER", label: this.$t("Usrs_name_owner") },
        { key: "POND_MANAGER", label: this.$t("Comn_managers") },
        { key: "POND_WORKER", label: this.$t("Usrs_pond_worker") },
        { key: "POND_TECHNICIAN", label: this.$t("Usrs_pond_techo") },
        { key: "NO_ACCESS", label: this.$t("Comn_no_access") }
      ];
    },
    getCurrUserLocation() {
      return this.$store.getters["user/getCurrUserLocation"];
    },
    isLocationAvailable() {
      return !(
        Object.keys(this.getCurrUserLocation).length === 0 &&
        this.getCurrUserLocation.constructor === Object
      );
    },
    getFormatUsers() {
      let formatedList = this.$lodash.cloneDeep(
        this.$store.getters["user/getUAMListArray"]
      );
      const { timezone, country } = formatedList[0]
        ? formatedList[0]
        : { timezone: "" };

      formatedList.forEach(user => {
        user.name = `${user.first_name} ${user.last_name}`;
        user.timezone = timezone;
        user.country = country;
      });

      const newFormatedList = this.$lodash.cloneDeep(
        formatedList.filter(
          user => user.user_type != "POND_OWNER" && user.user_type != "ADMIN"
        )
      );

      newFormatedList.sort(this.compare("user_type"));

      return [
        ...formatedList.filter(user => user.user_type === "ADMIN"),
        ...formatedList.filter(user => user.user_type === "POND_OWNER"),
        ...newFormatedList
      ];
    },
    getUAMListArray() {
      const searchList = this.getFormatUsers.filter(user => {
        return (
          !this.userSearch ||
          user.name.toLowerCase().includes(this.userSearch.toLowerCase())
        );
      });

      return searchList.filter(user => {
        return (
          !this.selectedUserIds.length ||
          this.selectedUserIds.includes(user.user_type)
        );
      });
    },
    getFilterList() {
      const formatedList = this.$lodash.cloneDeep(
        this.$store.getters["user/getUAMListArray"]
      );
      const { timezone, country } = formatedList[0]
        ? formatedList[0]
        : { timezone: "" };
      formatedList.forEach(user => {
        user.name = `${user.first_name} ${user.last_name}`;
      });

      const searchList = formatedList.filter(user => {
        return (
          !this.userSearch ||
          user.name.toLowerCase().includes(this.userSearch.toLowerCase())
        );
      });

      return searchList;
      // return this.$store.getters["user/getUAMListArray"];
    },

    isReadOnly() {
      return this.$store.getters["user/isReadOnly"];
    },
    tableColumns() {
      return {
        first_name: {
          prop: "name",
          label: "Name",
          sortMethod: this.$commonUtils.naturalSort("code"),
          minWidth: 120,
          sortable: true
        },
        status: {
          prop: "status",
          label: "Status"
          // width: 150
        },
        user_type: {
          prop: "user_type",
          label: "User Role"
        }
      };
    },
    getUserData() {
      if (!this.getUAMListArray.length > 0) return {};
      if (!this.selectedUser) {
        return this.getUAMListArray[0];
      }
      return this.getUAMListArray.filter(
        ({ _id }) => this.selectedUser === _id
      )[0];
    },
    getUAMListArrayIds() {
      return this.userTypes.map(type => type.key);
    },
    tableProps: function() {
      return {
        size: "mini",
        rowClassName: this.rowClassName
      };
    },
    sortMethodForColumns: function() {
      return {
        user_priority: (a, b) => this.$commonUtils.alphaNumericComparator(a, b)
      };
    }
  },
  created() {
    this.actionComponentTitles = {
      userAccessMgmtCreate: `${this.$t("Usrs_new_user")}`,
      userAccessMgmtEdit: `${this.$t("Usrs_edit_user")}`,
      userAccessMgmtUpdatePassword: `${this.$t("Comn_chng_usr_pwd")}`
    };
  },
  async mounted() {
    await this.loadUAMList();
    await this.loadUAMNoAccessList();
  },
  destroyed() {},
  methods: {
    loadUAMList: function() {
      this.$store
        .dispatch("user/fetchSubUserDetails", {
          location_id: this.getCurrUserLocation._id,
          get_all: true
        })
        .finally(() => {
          this.loading = false;
        });
    },
    compare(key) {
      return function(a, b) {
        if (a.key < b.key) {
          return 1;
        }
        if (a.key > b.key) {
          return -1;
        }
        return 0;
      };
    },
    loadUAMNoAccessList: function() {
      this.loading = true;
      this.$store
        .dispatch("user/fetchNoAccessSubUserDetails", {
          user_type: "NO_ACCESS",
          get_all: true
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async reload() {
      await this.loadUAMList();
      await this.loadUAMNoAccessList();
    },
    handleClick(user_type, componentName, userIndex = 0) {
      try {
        this.isHighPriorityUsersRestricted();
        if (componentName === "userAccessMgmtCreate") {
          // this.user_type = user_type;
          this.rightPanelViewType = componentName;

          this.dialogVisible = true;
          this.actionsComponent = componentName;
          this.user_details = new User();
          this.user_type = user_type;
        } else if (
          componentName === "userAccessMgmtEdit" ||
          componentName === "userAccessMgmtUpdatePassword"
        ) {
          // const temp_user = this.UAMList[user_type][userIndex];
          const temp_user = this.getUserData;
          this.rightPanelViewType = componentName;
          if (temp_user.user_type === "ADMIN") {
            this.$emit("change-tab", "userProfile");
          } else {
            this.user_type = user_type;
            this.dialogVisible = true;
            this.actionsComponent = componentName;
            this.rightPanelViewType = componentName;

            this.user_details = this.getUserData;
          }
        }
      } catch (err) {
        this.errorMessages(err, true);
      }
    },
    handleRowClick: async function(row, column, event) {
      this.selectedUser = row._id;
      this.actionsComponent = "details";
      this.rightPanelViewType = "details";
    },
    rowClassName({ row, rowIndex }) {
      if (row && this.selectedUser === row._id) {
        return "selected-row";
      } else {
        return "";
      }
    },
    handleCloseDialog(event) {
      this.dialogVisible = false;
      if (event === "success") {
        this.loadUAMList();
      }
    },
    async handleChangeSelectedUsers(selectedUserIds) {
      this.selectedUserIds = selectedUserIds;
    },
    getStatus(type) {
      if (type === "NO_ACCESS") {
        return "Inactive";
      } else {
        return "Active";
      }
    },
    handleAddPondClick() {
      try {
        this.isEditable(this.tabData);
        this.$router.push("map-view");
      } catch (error) {
        console.log(error);
        this.errorMessages(error, true);
      }
    }
  }
};
</script>

<style lang="scss">
.users-managment {
  .user-access-container {
    .user-table-scroll {
      position: relative;
      height: 81vh;
    }
    .user-table-scroll-view {
      padding-right: 10px;
    }
    .user-table-scroll-wrap {
      height: 100%;
      overflow-y: auto;
      overflow-x: auto;
    }
    .sub-header-left {
      padding: 14px;
      display: flex;
      align-items: center;
      border-left: 1px solid #dddddd;
      border-bottom: 1px solid #dddddd;
      .add-user-btn {
        display: flex;
        justify-content: flex-end;
        p {
          text-transform: uppercase;
        }
      }
    }
    .sub-header-right {
      @include responsiveProperty(padding, 12px, 12px, 15px);
      display: flex;
      align-items: center;
      border-left: 1px solid #dddddd;
      border-bottom: 1px solid #dddddd;
      .outline-btns-container {
        display: flex;
        justify-content: space-evenly;
        p {
          text-transform: uppercase;
        }
      }
      .el-row {
        display: flex;
        align-items: center;
      }
    }

    .left-container {
      border-left: 1px solid #dddddd;
      border-bottom: 1px solid rgb(221, 221, 221);
    }

    .name-container {
      display: flex;
      align-items: center;
    }
    .name-container * {
      margin-right: 15px;
      color: #0a2463 !important;
    }
    .add-container {
      display: flex;
      align-items: center;
      @include responsiveProperty(padding, 8px, 8px, 1.5px);
    }
    .add-container * {
      margin-right: 15px;
      color: #0a2463 !important;
    }
    .el-table {
      .el-table__header th {
        background-color: #f4f2ff !important;
        color: #0a2463 !important;
      }
      .table-main-text {
        color: #0a2463;
      }
      .table-header-text {
        color: #25213b;
        @include responsiveProperty(font-size, 13px, 16px, 19px);
      }
    }
    .active-user-tag {
      background: #33a02c;
      border-radius: 10px;
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      .circle {
        height: 6px;
        width: 6px;
        background-color: white;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
      }
    }
    .inactive-user-tag {
      background: #f2f0f9;
      border-radius: 10px;
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #0a2463;
      .circle {
        height: 6px;
        width: 6px;
        background-color: #0a2463;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
      }
    }
    .selected-row {
      background: aliceblue;
    }
  }
}
</style>
